<template lang="pug">
GenericCard.goals-panel(size='75')
  .sticky-top.bg-white
    .d-flex.justify-content-between.px-4.pt-4.pb-3
      .text-title.align-self-center
        | ประวัติการขายย้อนหลัง
      CustomInputSelectJson(
        v-model='filterYear'
        :options='availableYears'
        style='min-width: 72px'
      )
        //- option(value='') เลือกปี
        //- option(value=2018) 2018
        //- option(value=2019) 2019
        //- option(value=2020) 2020

  template(
    v-if='(months && months.length > 0) && filterYear'
    v-for='month in months'
  )
    MonthlyStat(
      :seller='seller'
      :month='month'
      :year='filterYear'
    )

  modal(
    name='product-group-stat'
    width='90%' height='auto'
    transition='modal-transition'
  )
    ProductGroupStat(
      :productGroup='selectedProductGroup'
      :ranking='selectedProductGroupIndex+1'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
import ProductGroupStat from '@/components/history/dialogs/BestSellings/ProductGroupStat.vue';
import MonthlyStat from './MonthlyStat.vue';

export default {
  props: {
    seller: {
      default: () => ({}),
    },
  },
  watch: {
    filterYear() {
      this.initMonthList();
    },
  },
  data() {
    return {
      filterYear: `${new Date().getFullYear()}`,
      // filterYear: this.$moment().subtract('year', 1).format('YYYY'),

      // daily: {
      //   commission: 31670.00,
      //   sales: 55123.00,
      // },
      // months: [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤษจิกายน',
      //   'ธันวาคม',
      // ],
      availableYears: [],
      months: [],
      MOCK_CUSTOMER: {
        name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
        total: '3,1670.00',
      },

      bestSellingsTableData: [],
      bestSellingsTableColumns: {
        name: { title: 'ชื่อ', align: 'left' },
        total: { title: 'ยอดรวม', align: 'right' },
      },

      bestSellingsGroupRatio: [],

      selectedProductGroup: [],
      selectedProductGroupIndex: -1,

      isLoading: false,

    };
  },
  mounted() {
    this.initYearList();
    this.initMonthList();
  },
  methods: {
    initYearList() {
      const START_YEAR = 2010;
      const CURRENT_YEAR = Number(this.$moment().format('YYYY'));
      // alert(`${START_YEAR} to ${CURRENT_YEAR}`);

      const availableYears = [];
      for (let i = START_YEAR; i <= CURRENT_YEAR; i += 1) {
        availableYears.push({
          value: i,
          text: `${i}`,
        });
      }

      this.availableYears = availableYears;
      // alert(JSON.stringify(availableYears));
    },
    initMonthList() {
      const TODAY = new Date();
      const monthList = [];

      for (let i = 0; i < 12; i += 1) {
        if (Number(this.filterYear) === TODAY.getFullYear()
          && i >= TODAY.getMonth()) {
          break;
        }
        monthList.push(i);
      }

      this.months = monthList;

      // alert(JSON.stringify(this.months));
    },
    bestSellingClicked(e) {
      this.selectedProductGroup = e.data;
      this.selectedProductGroupIndex = e.index;
      this.$modal.show('product-group-stat');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('product-group-stat');
    },
  },
  components: {
    ProductGroupStat,
    MonthlyStat,
  },
};
</script>

<style lang="scss">
// .goals-panel {}
</style>
